import * as React from "react";
import { getDisplayName } from "@grandvisionhq/utils";
import { useBloomreachData } from "../../hooks/hooks/use-bloomreach-data.js";
function withBloomreachData(Component) {
  const displayName = getDisplayName(Component);
  const WithBloomreachData = (props) => {
    const { ref, data } = useBloomreachData(props);
    if (!data || !data.content) {
      console.error(
        `Tried to render CmsComponent ${displayName} without content object with ref: ${ref}`
      );
      return /* @__PURE__ */ React.createElement(Component, { ...props });
    }
    return /* @__PURE__ */ React.createElement(Component, { ...data, ...props });
  };
  WithBloomreachData.displayName = `WithBloomreachData(${displayName})`;
  return WithBloomreachData;
}
export {
  withBloomreachData
};
//# sourceMappingURL=with-bloomreach-data.js.map
